"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInSession = void 0;
const rxjs_1 = require("rxjs");
const AccountService_1 = require("../AccountService");
const AccountSession_1 = require("./AccountSession");
class SignInSession extends AccountSession_1.AccountSession {
    constructor(params) {
        super(params, AccountService_1.VerifyCodeAction.login);
    }
    start(account, keepSignState = false) {
        this.account = account;
        this.verifyCodeType = account.indexOf("@") > 0 ? AccountSession_1.VerifyType.email_code : AccountSession_1.VerifyType.sms_code;
        this.subscription = (0, rxjs_1.from)(this.params.buAccount.login({
            account: account,
            keep_login_state: keepSignState,
            host: this.params.host,
            lang: this.params.lang,
            biometric_key_md5: this.params.biometricKeyMd5,
            enable_passkey: this.params.enablePasskey,
            passkey_support: this.params.passkeySupport,
        }, this.sessionHandler)).subscribe(this.params.onSuccess, this.params.onError);
    }
}
exports.SignInSession = SignInSession;
